/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_AmountInputs */

const en_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const fr_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant`)
};

const de_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge`)
};

const it_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantità`)
};

const ru_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество`)
};

const es_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad`)
};

const zh_cn2_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

const ja_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`額`)
};

const hi_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मात्रा`)
};

const pt_pt2_invoice_amount = /** @type {(inputs: Invoice_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantia`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Invoice_AmountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoice_amount = /** @type {((inputs?: Invoice_AmountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_AmountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_invoice_amount(inputs)
	if (locale === "de") return de_invoice_amount(inputs)
	if (locale === "it") return it_invoice_amount(inputs)
	if (locale === "ru") return ru_invoice_amount(inputs)
	if (locale === "es") return es_invoice_amount(inputs)
	if (locale === "zh-CN") return zh_cn2_invoice_amount(inputs)
	if (locale === "ja") return ja_invoice_amount(inputs)
	if (locale === "hi") return hi_invoice_amount(inputs)
	if (locale === "pt-PT") return pt_pt2_invoice_amount(inputs)
	return en_invoice_amount(inputs)
});